export class JobRate {
    constructor(
        public readonly rate: number,
        public readonly isUrgent: boolean
    ) {
        if (rate < 0) {
            throw new Error('Rate must be greater than 0');
        }
    }
}
